module.exports = __webpack_public_path__ + "static/ForTheKing1-cdde88ed20e56313e6f0263bd99518a8.webp";